module.exports = __webpack_public_path__ + "static/img/software8.54c6ab0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/software8.jpg
// module id = 1Y8E
// module chunks = 2